import React from 'react'
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CEM from '../../assets/images/cem.jpeg'
const Board = ({ title }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-sm-12">
            <img src={CEM} alt="" className='rounded float-start mt-4 p-4 ' width='300' />
            <p className='mt-2 text-center'>
              
            Hon'ble CEM of BTR 
            <br />
            <strong>Pramod Boro</strong>
            </p>
        </div>
        <div className="col-md-8 col-sm-12">
        <div className="content">
      <h3 className='text-center fw-bold mb-2'>हामब्लायथि रादाब</h3>
      <hr />
         <p  style={{textAlign:'justify'}}>नोंथांनि लाइजामनि गेजेरजों बिटिआरनि गेलेमु आरो लाइमोन अनसाइ बिफाना www.syw.bodoland.gov.in मुंनि बिफानारि वेबसाइड बेखेवनो नागिरनाय खौराांखौ मिथिनो मोन्नाने आं जोबोद गोजोन्नाय मोन्दों लोगोसे वे वेबसाइडआ गेलेमु विथिनि गोनांथार गासिबो खौराां आरो खाबुफोरखो मिथिहोनायनि राहा खालामनो नागिरनाय खोटाया थारैनो जों बयनिबो थाखाय गोजोनथाव बाथ्रा । विटिआर ओनसोला मोनसे गेलेमु बिथिंनि गोजों इयुन थानाय गोनांथार ओनसोल । बे ओनसोलखौ जों गेलेमु बिथिंडाव जेसेबां जोथोन लानो हागोन एसेबां बेनिफ्राय सानसे मुलुग देरहासार गेलेगिरि सोरजिनो हानायनि लामाया गेवगोन। बेनिखायनो वे वेबसाइडयाव गेलेमु आरो राफोदथिजों सोमोन्दो थानाय गासिबो खोरांखो मिथिहोनाय गाहाम राहा सोरजिनो लानो हागोन होन्नाने मिजिंथिनाय जाबाय । मानोना जोनि जाखांफुनाय बे हालामनि लाइमोनफोरखौ गेलेमु बिथिनि गोनांथार रादाबखौ नांगौ समाव नांगोबाइदि रोखोमै मिथिहोनो हायोब्ला बिटिआर हालामनि लाइमोनफोरा गोबां मुलाम्फा जागोन होन्नानै आं फोथायो ।</p>
        <p  style={{textAlign:'justify'}}>
        जोबनायाव नोंथांनि गोसो गोथारै नाजानायाव बिटिआरनि गेलेमु आरो लाइमोन अनसाइआ बे खामानिखौ मावनो सिगांबोनायनि थाखाय नोंथांनिसिम साबायखर जासिहरबाय आरो नोंथांनि नाजानायाव बेखेवनो लानाय वेबसाइडआ जेरावबो जेरैबो बिथिङाव साबना-हामना जानायजों लोगोसे गासिबो विथिङाव जाफुंसारनो हाथों ।</p>

        <a className="link btn btn-outline-secondary"  href='../../assets/download/CEM Message.pdf' download>Download</a>
      </div>
        </div>
      </div>
    </div>
  )
}

export default Board